import type { IProps } from '../models';

type TCheckIsSamePage = Pick<IProps, 'urlEqHref' | 'href' | 'collectorData'>;

// Совпадает ли урл страницы с указанным в href
export const checkIsSamePage = ({ collectorData, href, urlEqHref }: TCheckIsSamePage) => {
    if (urlEqHref && href) {
        href = href.replace(/<ORIGIN_PH>|<MASTER_ORIGIN_PH>/, '');

        const isAbsolute = /^https?:\/\//.test(href);

        return isAbsolute
            ? href === `${collectorData?.origin}${collectorData?.url}`
            : href === collectorData?.url;
    }

    return false;
};
